//Get Category
export const GET_CATEGORY = "GET_CATEGORY";

//Insert Category
export const INSERT_CATEGORY = "INSERT_CATEGORY";

//Update Category
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";

//Delete Category
export const DELETE_CATEGORY = "DELETE_CATEGORY";

//Insert Open Dialog
export const OPEN_CATEGORY_DIALOG = "OPEN_CATEGORY_DIALOG";

//Close Dialog
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//toast
export const OPEN_CATEGORY_TOAST = "OPEN_CATEGORY_TOAST";
export const CLOSE_CATEGORY_TOAST = "CLOSE_CATEGORY_TOAST";
